__turbopack_context__.v({
  "backBtn": "styles-module__nFp8Qq__backBtn",
  "backIcon": "styles-module__nFp8Qq__backIcon",
  "catalogContent": "styles-module__nFp8Qq__catalogContent",
  "catalogWrap": "styles-module__nFp8Qq__catalogWrap",
  "filtersBody": "styles-module__nFp8Qq__filtersBody",
  "filtersHeader": "styles-module__nFp8Qq__filtersHeader",
  "filtersOverlay": "styles-module__nFp8Qq__filtersOverlay",
  "open": "styles-module__nFp8Qq__open",
});
